export default __webpack_public_path__ + "static/media/hero-background-por-que-escogernos.344469be.jpg";